import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CALL_STATUS } from "./constants";
import mediaAPI from "../../api/media";
import { deleteMedia, likeMedia, unlikeMedia, blockMedia, blockUser } from "./media.reducer";

const initialState = {
	status: CALL_STATUS.IDLE,
	error: null,
	data: []
}

export const getFavorites = createAsyncThunk('favorites/getFavorites', async (token) => {
	const response = await mediaAPI.getFavorites(token);
	return response;
});

export const addFavorite = createAsyncThunk('favorites/addFavorite', async ({ mediaPoint, token }) => {
	await mediaAPI.addFavorite(mediaPoint.id, token);
	return mediaPoint;
});

export const removeFavorite = createAsyncThunk('favorites/removeFavorite', async ({ mediaId, token }) => {
	await mediaAPI.removeFavorite(mediaId, token);
	return mediaId;
});

const favoritesSlice = createSlice({
	name: "favorites",
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(getFavorites.pending, (state) => {
				state.status = CALL_STATUS.PENDING;
				state.error = null;
			})
			.addCase(getFavorites.fulfilled, (state, action) => {
				state.status = CALL_STATUS.SUCCESS;
				state.error = null;
				state.data = action.payload.data;
			})
			.addCase(getFavorites.rejected, (state, action) => {
				state.status = CALL_STATUS.ERROR;
				state.error = action.error.message;
			})
			.addCase(addFavorite.fulfilled, (state, action) => {
				if (!state.data.find(item => item.id === action.payload.id)) {
					state.data.push(action.payload);
				}
				state.error = null;
			})
			.addCase(addFavorite.rejected, (state, action) => {
				state.error = action.error.message;
				console.error("Failed to add favorite:", action.error.message);
			})
			.addCase(removeFavorite.fulfilled, (state, action) => {
				state.data = state.data.filter(item => item.id !== action.payload);
				state.error = null;
			})
			.addCase(removeFavorite.rejected, (state, action) => {
				state.error = action.error.message;
				console.error("Failed to remove favorite:", action.error.message);
			})
			.addCase(likeMedia.pending, (state, action) => {
				const media = state.data.find(p => p.id === action.meta.arg.mediaId);
				if (media) {
					media.likedByCurrentUser = true;
					media.likesCount += 1;
				}
			})
			.addCase(likeMedia.rejected, (state, action) => {
				const media = state.data.find(p => p.id === action.payload);
				if (media) {
					media.likedByCurrentUser = false;
					media.likesCount = Math.max(0, media.likesCount - 1);
				}
			})
			.addCase(unlikeMedia.pending, (state, action) => {
				const media = state.data.find(p => p.id === action.meta.arg.mediaId);
				if (media) {
					media.likedByCurrentUser = false;
					media.likesCount = Math.max(0, media.likesCount - 1);
				}
			})
			.addCase(unlikeMedia.rejected, (state, action) => {
				const media = state.data.find(p => p.id === action.payload);
				if (media) {
					media.likedByCurrentUser = true;
					media.likesCount += 1;
				}
			})
			.addCase(deleteMedia.fulfilled, (state, action) => {
				if (state.data) {
					state.data = state.data.filter(item => item.id !== action.payload);
				}
			})
			.addCase(blockMedia.fulfilled, (state, action) => {
				if (state.data) {
					state.data = state.data.filter(item => item.id !== action.payload);
				}
			})
			.addCase(blockUser.fulfilled, (state, action) => {
				if (action.meta.arg.blockVideos) {
					if (state.data) {
						const userId = action.payload;
						state.data = state.data.filter(media => media.ownerId !== userId);
					}
				}
			});
	}
});

const { actions, reducer } = favoritesSlice;

export const {
	reset
} = actions;

export default reducer;